import React, { useEffect, useRef, useState } from "react";
import * as THREE from "three";
import "bootstrap/dist/css/bootstrap.min.css";
import LayOut from "../components/LayOut";
import "./Styles/about.css";
import ProfilePhoto from "../../assets/profile photo.jpg";
import { Link } from "react-router-dom";

const AboutPage = () => {
  const canvasRef = useRef(null);
  const [typedText, setTypedText] = useState("");

  const typingText = [
    "Hi,",
    "I'm Akash Kumar Dubey,",
    "A Full Stack Developer.",
    "I build modern web applications.",
  ];

  useEffect(() => {
    // Typing Animation
    let currentIndex = 0;
    let charIndex = 0;

    const type = () => {
      if (currentIndex < typingText.length) {
        if (charIndex <= typingText[currentIndex].length) {
          setTypedText((prev) =>
            prev
              .split("\n")
              .slice(0, currentIndex)
              .concat(typingText[currentIndex].slice(0, charIndex))
              .join("\n")
          );
          charIndex++;
          setTimeout(type, 100);
        } else {
          charIndex = 0;
          currentIndex++;
          setTimeout(type, 500);
        }
      }
    };

    type();

    // Three.js Background Animation
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(
      75,
      canvasRef.current.clientWidth / canvasRef.current.clientHeight,
      0.1,
      1000
    );
    const renderer = new THREE.WebGLRenderer({ alpha: true });
    renderer.setSize(
      canvasRef.current.clientWidth,
      canvasRef.current.clientHeight
    );
    canvasRef.current.appendChild(renderer.domElement);

    const particleCount = 500;
    const particles = new THREE.BufferGeometry();
    const positions = [];

    for (let i = 0; i < particleCount; i++) {
      positions.push(
        (Math.random() - 0.5) * 100, // x
        Math.random() * 50 - 25, // y
        (Math.random() - 0.5) * 100 // z
      );
    }

    particles.setAttribute(
      "position",
      new THREE.Float32BufferAttribute(positions, 3)
    );

    const material = new THREE.PointsMaterial({
      color: 0xff69b4,
      size: 0.4,
    });

    const pointCloud = new THREE.Points(particles, material);
    scene.add(pointCloud);

    camera.position.z = 20;

    const animate = () => {
      requestAnimationFrame(animate);
      pointCloud.rotation.y += 0.002; // Rotate particles
      renderer.render(scene, camera);
    };

    animate();

    return () => {
      renderer.domElement.remove();
    };
  }, []);

  return (
    <LayOut title="About Page">
      <div className="about-container">
        {/* Background Animation */}
        <div className="threejs-container" ref={canvasRef}></div>

        {/* About Content */}
        <div className="about-page">
          {/* Left Side Text */}
          <div className="left-side">
            <pre className="typing-text">{typedText}</pre>
          </div>

          {/* Right Side Image */}
          <div className="right-side">
            <img src={ProfilePhoto} alt="Profile" className="profile-img" />
            {/* Fixed Button */}
            <button className="fixed-button btn btn-pink">
              <Link to="/contact" className="Lin">
                Contact Me
              </Link>
            </button>
          </div>
        </div>
      </div>
    </LayOut>
  );
};

export default AboutPage;
